export const END_COUNTER = 'BETTER LUCK NEXT TIME!'
export const CONGRATS_FIND_ALL = 'CONGRATS! YOU FOUND THEM ALL.'
export const ANIMATION_DURATION = 1400
export const CIRCLE_SIZE = 30

export const MODAL_WIN_TITLE = 'Congrats! You found them all.'
export const MODAL_WIN_SUBTITLE = 'Congrats! You found them all!'
export const MODAL_LOSE_TITLE = 'Better luck next time!'
export const MODAL_LOSE_SUBTITLE = "You didn't find all the differences in time."
export const MODAL_AT_LEAST_ONE_WIN_TITLE = 'Well Done!'
export const MODAL_AT_LEAST_ONE_WIN_SUBTITLE = ({ wonScenes, totalScenes }) =>
  `You got ${wonScenes} out of ${totalScenes} scenes.`
